import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { isJapanese } from '../../../utils/lang';
import ExternalLink from './ExternalLink';

/**
 * 外部送信規律に関するANA公式ページへのリンクのコンポーネント。
 */
const ExternalTransmissionDiscipline: React.FC = () => {
  const { t, i18n } = useTranslation();
  /** 日本語版のURL。 */
  const urlJa = 'https://www.ana.co.jp/ja/jp/guide/terms/cookiepolicy/external_transmission/';
  /** 英語版のURL。 */
  const urlEn = 'https://www.ana.co.jp/en/jp/guide/terms/cookiepolicy/external_transmission/';
  /** リンクとして設定するURL。 */
  // 言語設定に応じてリンク先を切り替える。
  const url = isJapanese(i18n.language) ? urlJa : urlEn;
  return (<ExternalLink url={url} label={t('external_transmission_discipline')}/>);
};

export default ExternalTransmissionDiscipline;
